export default __webpack_public_path__ + "static/media/st5.3bc27ecb.jpg";